<template>
  <div>
    <div class="columns">
      <div class="column has-text-centered">
        <div
          v-for="(editionAInclure, index) in editionsAInclure"
          :key="index"
          class="mgb-10px is-inline-block">
          <b-field class="mgr-10px">
            <qd-switch
              v-model="editionAInclure.value"
              type="is-primary">
            </qd-switch>
            <span> {{ $t(editionAInclure.libelle) }}</span>
          </b-field>
        </div>
      </div>
    </div>
    <div class="columns">
        <div class="column has-text-centered">
          <b-upload v-model="piecesJointes"
                      multiple
                      drag-drop>
              <div class="content">
              <div class="mg-5px">
                  <b-icon icon="upload" type="is-primary" size="is-small"></b-icon>
                  <span>{{ $t('mail.actions.pj') }}</span>
              </div>
              </div>
          </b-upload>
        </div>
    </div>
    <div>
        <div class="card mgb-10px"
            v-for="(pj, index) in piecesJointes" :key="index">
        <div class="card-content level">
            <div class="level-left">
            <b-icon icon="file-document" type="is-default"></b-icon>
            <span class="mgl-10px ellipsis width-100">{{ pj.name }}</span>
            </div>
            <div class="level-right is-cursor-pointer" @click="deletePieceJointe(pj)">
            <b-icon icon="delete" type="is-danger"></b-icon>
            </div>
        </div>
        </div>
        <br>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RelanceMailOption',
  props: {
    editionsAInclure: {
      type: Array,
      required: true,
    },
    piecesJointes: {
      type: Array,
      required: true,
    },
  },
  methods: {
    deletePieceJointe(pj) {
      const index = this.piecesJointes.indexOf(pj);
      this.piecesJointes.splice(index, 1);
    },
  },
};
</script>
